import Freezer from 'freezer-js';
import config from './../store/index.js';

/* Refactor necessary
   - Do not use a single store for different types of data. E.g. calling it
     ”store” (generic) and having both game data & filter data in it.
   	 Reason: Separation of concerns & single responsibility: there should only be one reason
   	 to modify something
   - There should not be direct access to the store.
   	 E.g. provide access through getter functions:
   	 	getAllgames() instead of store.get().foo.bar.allGames
     Reason: When data structure changes, there should be no need
     to modify other code.
     Example: This commit. There was a need to change what data was retrieved from server
     	for all games, which resulted in a need to modify:
     		this file, bundles.js, mygames.js, providergames.js, allgames.js, selectors.js
     	(Only this file should need to change)

   - Do not use freezer for gameData & templates if they are not meant to change
     Reason: The code is written so that gameData never changes (after initial load),
     which means using freezer for gameData is completely pointless.
 */
const initialState = {
	templates: {
		games: () => '',
	},
	gameResource: {
		gameData: {
			all: []
		},
		i18n: {},
		siteCode: config.siteCode
	},
	filters: {
		key: null,
		provider: null
	}
};

const store = new Freezer(initialState);

export { store };



// WEBPACK FOOTER //
// ./mobile-core/src/casino/store.js